export default __webpack_public_path__ + "media/images/feature_google-cd735fc7321fd225995ffcc068b61d07.png";